/**
 * Speech-agent domain — Branded ID types
 */
import { Schema } from "effect";

export const AgentId = Schema.String.pipe(
  Schema.brand("AgentId")
);
export type AgentId = typeof AgentId.Type;
